__turbopack_context__.v({
  "container": "MwXDNW_container",
});
